import constants from '../constants/index';

const ScheduleActions = {
	selectSchool: function(data) {
		return {
			type: constants.SELECT_SCHOOL,
			payload: {
				school: data.school,
				term: data.term
			}
		}
	},
	
	requestSchedules: function(data) {
		return (dispatch, getState, clients) => {

			dispatch(this.selectSchool(data));
			dispatch({
				type: constants.REQUEST_SCHEDULES,
				payload: data
			});

			return clients.schedule.getList({
				school: data.school,
				term: data.term
			})
			.then(
				schedules => {
					dispatch(this.requestSchedulesSuccess(schedules));
					dispatch(this.requestSchedule({
						school: data.school,
						term: data.term,
						scheduleId: !data.scheduleId && schedules[0] ? schedules[0].id : data.scheduleId
					}));
				},
				err => {
					dispatch(this.requestSchedulesFail(err))
				}
			);

		};
	},

	requestSchedulesSuccess: function(schedules) {
		return {
			type: constants.REQUEST_SCHEDULES_SUCCESS,
			payload: {
				schedules: schedules
			}
		}
	},

	requestSchedulesFail: function(err) {
		console.log(err);
		return {
			type: constants.REQUEST_SCHEDULE_FAIL,
			payload: {

			}
		}
	},

	changeSchedule: function(id) {
		return {
			type: constants.CHANGE_SCHEDULE,
			payload: {
				id: id
			}
		};
	},

	requestSchedule: function(data) {
		return (dispatch, getState, clients) => {
			dispatch({
				type: constants.REQUEST_SCHEDULE,
				payload: {}
			});

			return clients.schedule.get({	
				school: data.school,
				term: data.term,
				scheduleId: data.scheduleId,
			})
			.then(
				schedule => {
					dispatch(this.requestScheduleSuccess(schedule));
				},
				err => {
					dispatch(this.requestScheduleFail(err))
				}
			);
		};
	},

	requestScheduleSuccess: function(schedule) {
		return (dispatch, getState, clients) => {
			dispatch(this.requestTeachersSuccess(schedule.teachers));
			dispatch(this.requestCohortsSuccess(schedule.cohorts));
			dispatch(this.requestMeetingsSuccess(schedule.meetings));
			dispatch(this.requestScheduledMeetingsSuccess(
				schedule.scheduledMeetings)
			);
			return dispatch({
				type: constants.REQUEST_SCHEDULE_SUCCESS,
				payload: {
					schedule
				}
			});
		};
	},

	requestScheduleFail: function(err) {
		console.log(err);
		return {
			type: constants.REQUEST_SCHEDULE_FAIL,
			payload: {

			}
		}
	}
};

export default ScheduleActions;


/** WEBPACK FOOTER **
 ** ./src/js/actions/schedule_actions.js
 **/